import { useSettings } from "context/SettingsContext";
export const ProductSwiperShimmer = ({ count = 5 }) => {
  const { theme } = useSettings();
  const isDark = theme === "dark";
  return (
    <div
      className={`flex-shrink-0 w-[225px] md:w-[200px] max-md:basis-[47%] 
      ${isDark ? "bg-gray-800" : "bg-white"} 
      rounded-[10px] overflow-hidden`}
    >
      {/* Image skeleton */}
      <div
        className={`w-full aspect-[4/5] relative rounded-t-[10px] overflow-hidden
        ${isDark ? "bg-gray-700" : "bg-gray-300"}`}
      >
        <div
          className={`absolute inset-0 animate-shimmer
          ${
            isDark
              ? "bg-gradient-to-r from-gray-700 via-gray-600 to-gray-700"
              : "bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300"
          }`}
        />
      </div>

      {/* Text skeleton */}
      <div className="p-2 flex flex-col gap-2">
        <div
          className={`h-4 w-3/4 rounded relative overflow-hidden
          ${isDark ? "bg-gray-700" : "bg-gray-300"}`}
        >
          <div
            className={`absolute inset-0 animate-shimmer
            ${
              isDark
                ? "bg-gradient-to-r from-gray-700 via-gray-600 to-gray-700"
                : "bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300"
            }`}
          />
        </div>

        <div
          className={`h-4 w-1/2 rounded relative overflow-hidden
          ${isDark ? "bg-gray-700" : "bg-gray-300"}`}
        >
          <div
            className={`absolute inset-0 animate-shimmer
            ${
              isDark
                ? "bg-gradient-to-r from-gray-700 via-gray-600 to-gray-700"
                : "bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300"
            }`}
          />
        </div>
      </div>
    </div>
  );
};
